import { Link } from "react-router";
import { logoLatest } from "@/assets/images";

export default function AuthLayout({ children }) {
  return (
    <div className="relative p-6 bg-white z-1 sm:p-0">
      <div className="relative flex flex-col justify-center w-full h-screen lg:flex-row sm:p-0">
        {children}
        <div className="items-center hidden w-full h-full lg:w-1/2 bg-gray-900 lg:grid">
          <div className="relative flex items-center justify-center z-1">
            <div className="flex flex-col items-center max-w-xs">
              <Link to="/" className="block mb-4">
                <img
                  width={231}
                  height={48}
                  src={logoLatest}
                  alt="Logo"
                  className="brightness-0 invert"
                />
              </Link>
              <p className="text-center text-gray-400">
                Your reliable ride, anytime, anywhere
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
